import moment from 'moment';
import { DEFAULT_PARTNER } from './constants';

export const extractWeddingNames = weddingDetails => {
  if (
    !(weddingDetails.fullName && weddingDetails.fullName.split(' ').length > 1) ||
    (!weddingDetails.hasNoPartner &&
      !(weddingDetails.partnerFullName && weddingDetails.partnerFullName.split(' ').length > 1))
  ) {
    return null;
  }

  const [ownerUserFirstName, ...ownerUserLastNames] = weddingDetails.fullName.split(' ');
  const [partnerUserFirstName, ...partnerUserLastNames] = weddingDetails.partnerFullName
    ? weddingDetails.partnerFullName.split(' ')
    : [DEFAULT_PARTNER.firstName, DEFAULT_PARTNER.lastName];

  return {
    owner_first_name: ownerUserFirstName,
    owner_last_name: ownerUserLastNames.join(' '),
    partner_first_name: partnerUserFirstName,
    partner_last_name: partnerUserLastNames.join(' '),
  };
};

export const parseWeddingDate = date => {
  if (!date) {
    return null;
  }

  if (date.length !== 10) {
    return null;
  }

  const parsedDate = moment(
    `${date.substring(0, 4)}-${date.substring(5, 7)}-${date.substring(8, 10)}`
  );

  if (!parsedDate.isValid()) {
    return null;
  }

  return parsedDate;
};

export const getUserTimeZone = () => moment.tz.guess();

export const getAccountCreationTimestamp = () => moment.utc().format();

const PX_TO_PT_RATIO = 16 / 12;

export const ptToPx = pt => pt * PX_TO_PT_RATIO;

export const pxToPt = px => px / PX_TO_PT_RATIO;

export const isIeEleven = () => {
  const ua = window.navigator.userAgent;
  const trident = ua.indexOf('Trident/');
  if (trident > 0) {
    const rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10) === 11;
  }
  return false;
};



// WEBPACK FOOTER //
// ./src/paper/utils/helpers.js